<template>
    <div>
        <div v-if="submissionStatus != 'p'" class="centerTbl">
                <h2 style="padding:0.8rem 0; border-bottom:solid 1px #666;">
                    <img :src="approvalIconImg" style="width:75px;height:auto;" />
                    <span :class="approvalClass">{{ activity }} {{ approvalTxt }}</span>
                </h2>
        </div>
        <div v-else-if="submissionStatus == 'p'" class="centerTbl">
            <table id="wfChart">
                <tr id="wfChartCurrentTr">
                    <td>&nbsp</td>
                    <td v-for="step in maxSteps" :style="applyEndLine(step)">
                        <span v-if="stepsData[step - 1] && stepsData[step - 1].isCurrent">
                            CURRENT<br>
                            <img src=/images/price-workflow/wf-flowchart-step-arrow.png />
                        </span>
                    </td>
                </tr>
                <tr>
                    <td id="wfChartIndicatorTd">
                        <img src="/images/price-workflow/wf-flowchart-left-green.png" />
                    </td>
                    <td id="wfChartIndicatorTd" v-for="step in maxSteps" :style="applyEndLine(step)">
                        <img :src="getStepImage(step)" />
                    </td>
                </tr>
                <tr>
                    <td id="positionNameTd">
                        SUBMITTED<br />
                        <span>{{ createdByFullName }}</span>
                    </td>
                    <td id="positionNameTd" v-for="step in maxSteps" :style="applyEndLine(step)">
                        {{ signOffPositions[step - 1] }} <br>
                        <span v-if="stepsData[step - 1]">{{ stepsData[step - 1].user_name }}</span>
                        <span v-else>&nbsp</span>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activity: null,
            approvalClass: null,
            approvalIconImg: null,
            approvalTxt: null,
            createdByFullName: null,
            maxSteps: 4, // default value
            signOffPositions: ['RSM', 'SD', 'VP', 'EXEC'], // default sign off positions
            submissionStatus: null,
            wfStepCurrent: null,
            wfSteps: null,
            wfStepStart: null,
            wfStepUser: null,
        }
    },
    props: ['stepsData', 'submission'],
    watch: {
        submission() {
            this.activity = this.submission.activity.activity;
            this.createdByFullName = this.submission.created_by_user.full_name;
            this.submissionStatus = this.submission.pp_status;
            this.wfStepCurrent = this.submission.wf_step_current;
            this.wfSteps = this.submission.wf_steps;
            this.wfStepStart = this.submission.wf_step_start;
            this.wfStepUser = this.submission.wf_step_user;

            if(this.submission.atgCheck) {
                this.signOffPositions = ['RSM', 'SD', 'SSD', 'VP', 'EXEC'];
                this.maxSteps = 5;
            }
        },
        submissionStatus () {
            if(this.submissionStatus == "a") {
                this.approvalIconImg = '/images/price-workflow/wf-icon-approve.png';
                this.approvalTxt = 'Approved';
                this.approvalClass = 'approvalCssApproved';
            } else if (this.submissionStatus == "d") {
                this.approvalIconImg = '/images/price-workflow/wf-icon-deny.png';
                this.approvalTxt = 'Denied';
                this.approvalClass = 'approvalCssDenied';
            } else if (this.submissionStatus == "e") {
                this.approvalIconImg = '/images/price-workflow/wf-icon-entered.png';
                this.approvalTxt = 'Entered into ERP'
                this.approvalClass = 'approvalCssErp'
            }
        },
    },
    methods: {
        applyEndLine(step) {
           return (this.wfSteps == step && step <= (this.maxSteps - 1))  ?  'border-right:solid 1px #cd1b00' : '';
        },
        getStepImage(step) {
            let stepData = this.stepsData[step - 1];

            if(stepData && (this.wfStepUser >= this.wfSteps && step <= this.wfStepUser) || this.wfStepStart > step) {
                switch(stepData["status"]) {
                    case 's':                        
                        return `/images/price-workflow/wf-flowchart-skip.png`;
                    default:
                        return `/images/price-workflow/wf-flowchart-green.png`;
                }
            } else if (this.wfSteps < step) {
                return `/images/price-workflow/wf-flowchart-gray.png`;
            } else if (this.wfSteps >= step && this.wfStepCurrent <= step) {
                if(stepData["status"] == 'h') {
                    return `/images/price-workflow/wf-flowchart-hold.png`;
                } else {
                    return `/images/price-workflow/wf-flowchart-empty.png`;
                }
            } else if (stepData) {
                switch(stepData["status"]) {
                    case 'd':
                        return `/images/price-workflow/wf-flowchart-red.png`;
                    case 'a':
                        return `/images/price-workflow/wf-flowchart-green.png`;
                    case 's':
                        return `/images/price-workflow/wf-flowchart-skip.png`;
                }
            }
        },
    }
}
</script>

<style scoped>
    .approvalCssApproved {
        position:relative;
        color:#3aa133;
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
        font-weight:normal;
    }

    .approvalCssDenied {
        position:relative;
        color:#cd1b00;
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
        font-weight:normal;
    }

    .approvalCssErp {
        position:relative;
        color:#0c0982;
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
        font-weight:normal;
    }

    #wfChart {
        width:100%;
    }

    #wfChartCurrentTr {
        color:#cd1b00; 
        font-size:0.6rem; 
        padding-bottom:3px;
        text-align:center;
    }

    #wfChartIndicatorTd {
        background:url('/images/price-workflow/wf-flowchart-bg.png') repeat-x;
        text-align:center;
    }

    #positionNameTd {
        text-align:center;
    }

    #positionNameTd span {
        font-size:0.8rem;
        color:#999;
        text-transform:uppercase;
    }
</style>